(function () {
  'use strict';

  var ROW_DEFS = [
    { key: 'sku', label: 'SKU' },
    { key: 'product_range', label: 'Product Range' },
    { key: 'product_type', label: 'Product Type' },
    { key: 'year_range', label: 'Year Range' },
    { key: 'vehicle_id', label: 'Vehicle ID' },
    { key: 'engine', label: 'Engine' },
    { key: 'model', label: 'Model' },
    { key: 'brand', label: 'Brand' },
    { key: 'body_style', label: 'Body Style' },
    { key: 'doors', label: 'Doors' },
    { key: 'front_lowering', label: 'Front Lowering (up to)' },
    { key: 'rear_lowering', label: 'Rear Lowering (up to)' },
    { key: 'axle_weights', label: 'Axle Weights' },
    { key: 'front_strut', label: 'Front Strut Ø Diameter' },
    { key: 'suspension_type', label: 'Suspension Type' },
    { key: 'availability', label: 'Availability' },
    { key: 'price', label: 'Price' }
  ];

  function normalizeValue(value) {
    return String(value == null ? '' : value).trim().toLowerCase();
  }

  function displayValue(value) {
    var text = String(value == null ? '' : value).trim();
    return text === '' ? '—' : text;
  }

  function rowHasDifference(values) {
    if (!values.length) return false;
    if (values.length === 1) return true;

    var normalized = values.map(normalizeValue);
    var first = normalized[0];
    for (var i = 1; i < normalized.length; i++) {
      if (normalized[i] !== first) return true;
    }
    return false;
  }

  function rowHasAnyValue(values) {
    return values.some(function (value) {
      return normalizeValue(value) !== '';
    });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseProductPayload(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var node = doc.querySelector('[data-koni-compare-product]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function KoniCompareTable(compareProduct, options) {
    options = options || {};
    this.compare = compareProduct;
    this.root = options.root || document.querySelector('.koni-compare-page');
    this.table = options.table || (this.root && this.root.querySelector('[data-koni-compare-table]'));
    this.scroll = options.scroll || (this.root && this.root.querySelector('[data-koni-compare-scroll]'));
    this.emptyEl = options.emptyEl || (this.root && this.root.querySelector('[data-koni-compare-modal-empty]'));
    this.isModal = !!options.isModal;
    this.diffOnly = false;
    this.products = [];
  }

  KoniCompareTable.prototype.fetchProduct = function (handle) {
    return fetchCache('/products/' + handle + '?view=compare').then(function (html) {
      return parseProductPayload(html);
    });
  };

  KoniCompareTable.prototype.getHandles = function () {
    var max = (this.compare.maxProducts || 6);
    return Array.from(new Set(this.compare.products || [])).slice(0, max);
  };

  KoniCompareTable.prototype.showEmpty = function () {
    if (this.isModal) {
      if (this.table) {
        this.table.innerHTML = '';
        this.table.classList.remove('is-visible');
      }
      if (this.emptyEl) this.emptyEl.classList.remove('m:hidden');
      return;
    }

    var content = this.root && this.root.querySelector('.m-compare-page-content');
    var empty = this.root && this.root.querySelector('.m-compare-no-products');
    if (content) content.classList.add('m:hidden');
    if (empty) empty.classList.remove('m:hidden');
  };

  KoniCompareTable.prototype.showTable = function () {
    if (this.isModal) {
      if (this.emptyEl) this.emptyEl.classList.add('m:hidden');
      return;
    }

    var content = this.root && this.root.querySelector('.m-compare-page-content');
    var empty = this.root && this.root.querySelector('.m-compare-no-products');
    if (content) content.classList.remove('m:hidden');
    if (empty) empty.classList.add('m:hidden');
  };

  KoniCompareTable.prototype.updateModalSize = function () {
    if (!this.isModal || !this.root) return;

    var cols = this.products.length;
    var isMobile = window.innerWidth <= 767;
    var labelWidth = isMobile ? 100 : 140;
    var colWidth = isMobile ? 180 : 200;
    var bodyPadding = isMobile ? 24 : 56;
    var maxWidth = window.innerWidth - 40;
    var totalWidth = labelWidth + (cols * colWidth) + bodyPadding;

    if (!isMobile && totalWidth > maxWidth) {
      colWidth = Math.max(130, Math.floor((maxWidth - labelWidth - bodyPadding) / cols));
      totalWidth = labelWidth + (cols * colWidth) + bodyPadding;
    }

    this.root.style.setProperty('--koni-compare-label-width', labelWidth + 'px');
    this.root.style.setProperty('--koni-compare-cols', cols);
    this.root.style.setProperty('--koni-compare-product-col-width', colWidth + 'px');
  };

  KoniCompareTable.prototype.buildModalTableHTML = function (products) {
    var cols = products.length;
    var viewDetails = (window.MinimogStrings && window.MinimogStrings.viewDetails) || 'View Details';
    var html = '<div class="koni-compare-modal-grid" style="--koni-compare-cols:' + cols + '">';

    html += '<div class="koni-compare-modal-products">';
    html += '<div class="koni-compare-modal-cell koni-compare-modal-cell--label koni-compare-modal-cell--corner"></div>';
    products.forEach(function (product) {
      html += '<div class="koni-compare-modal-cell koni-compare-modal-cell--product" data-compare-handle="' + escapeHtml(product.handle) + '">';
      html += '<div class="koni-compare-modal-product">';
      html += '<div class="koni-compare-modal-product__media">';
      if (product.image) {
        html += '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="200" height="200">';
      } else {
        html += '<div class="koni-compare-modal-product__placeholder"></div>';
      }
      html += '<button type="button" class="koni-compare-product__remove koni-compare-modal-product__remove" data-product-handle="' + escapeHtml(product.handle) + '" aria-label="Remove from compare">';
      html += '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M1 1l8 8M9 1L1 9" stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/></svg>';
      html += '</button></div>';
      html += '<h3 class="koni-compare-modal-product__title">' + escapeHtml(product.title) + '</h3>';
      html += '<a class="koni-compare-modal-product__cta" href="' + escapeHtml(product.url) + '">' + escapeHtml(viewDetails) + '</a>';
      html += '</div></div>';
    });
    html += '</div>';

    var modalRows = [{ key: 'description', label: 'Description', topLevel: true }].concat(ROW_DEFS);

    modalRows.forEach(function (rowDef) {
      var values = products.map(function (product) {
        if (rowDef.topLevel) {
          return rowDef.key === 'description' ? (product.description || '') : '';
        }
        return product.attributes[rowDef.key] || '';
      });

      if (!rowHasAnyValue(values)) return;

      var hasDiff = rowHasDifference(values);
      html += '<div class="koni-compare-modal-attr" data-compare-row="' + rowDef.key + '" data-has-difference="' + (hasDiff ? 'true' : 'false') + '">';
      html += '<div class="koni-compare-modal-cell koni-compare-modal-cell--label">' + escapeHtml(rowDef.label) + '</div>';
      values.forEach(function (value) {
        html += '<div class="koni-compare-modal-cell koni-compare-modal-cell--value"><span class="koni-compare-modal-cell__text">' + escapeHtml(displayValue(value)) + '</span></div>';
      });
      html += '</div>';
    });

    html += '</div>';
    return html;
  };

  KoniCompareTable.prototype.buildTableHTML = function (products) {
    if (this.isModal) {
      return this.buildModalTableHTML(products);
    }

    var cols = products.length;
    var html = '<div class="koni-compare-grid" style="--koni-compare-cols:' + cols + '">';

    html += '<div class="koni-compare-row koni-compare-row--products">';
    products.forEach(function (product) {
      html += '<div class="koni-compare-col koni-compare-col--product" data-compare-handle="' + product.handle + '">';
      html += '<div class="koni-compare-product">';
      html += '<div class="koni-compare-product__head">';
      html += '<span class="koni-compare-product__id">ID: ' + product.id + '</span>';
      html += '<button type="button" class="koni-compare-product__remove" data-product-handle="' + product.handle + '" aria-label="Remove from compare">';
      html += '<svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
      html += '</button></div>';
      html += '<a class="koni-compare-product__image" href="' + escapeHtml(product.url) + '">';
      if (product.image) {
        html += '<img src="' + escapeHtml(product.image) + '" alt="' + escapeHtml(product.title) + '" loading="lazy" width="180" height="180">';
      } else {
        html += '<div class="koni-compare-product__image-placeholder"></div>';
      }
      html += '</a>';
      html += '<h3 class="koni-compare-product__title"><a href="' + escapeHtml(product.url) + '">' + escapeHtml(product.title) + '</a></h3>';
      html += '<p class="koni-compare-product__price">' + escapeHtml(product.price) + '</p>';
      html += '<a class="koni-compare-product__link" href="' + escapeHtml(product.url) + '" aria-label="View product">';
      html += '<svg width="11" height="11" viewBox="0 0 11 11" fill="none" aria-hidden="true"><path d="M1 5.5h9M6 1l4 4.5L6 10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      html += '</a></div></div>';
    });
    html += '</div>';

    ROW_DEFS.forEach(function (rowDef) {
      var values = products.map(function (product) {
        return product.attributes[rowDef.key] || '';
      });

      if (!rowHasAnyValue(values)) return;

      var hasDiff = rowHasDifference(values);
      html += '<div class="koni-compare-row koni-compare-row--attr" data-compare-row="' + rowDef.key + '" data-has-difference="' + (hasDiff ? 'true' : 'false') + '">';
      html += '<div class="koni-compare-row__label">' + escapeHtml(rowDef.label) + '</div>';
      html += '<div class="koni-compare-row__cells">';
      values.forEach(function (value) {
        html += '<div class="koni-compare-col koni-compare-col--value"><span class="koni-compare-cell">' + escapeHtml(displayValue(value)) + '</span></div>';
      });
      html += '</div></div>';
    });

    html += '</div>';
    return html;
  };

  KoniCompareTable.prototype.applyDifferenceFilter = function () {
    if (!this.table) return;
    var rows = this.table.querySelectorAll('[data-compare-row]');
    rows.forEach(function (row) {
      var hasDiff = row.getAttribute('data-has-difference') === 'true';
      if (this.diffOnly && !hasDiff) {
        row.classList.add('is-hidden');
      } else {
        row.classList.remove('is-hidden');
      }
    }, this);
  };

  KoniCompareTable.prototype.updateScrollButtons = function () {
    if (this.isModal || !this.scroll || !this.root) return;
    var prev = this.root.querySelector('[data-koni-compare-scroll-prev]');
    var next = this.root.querySelector('[data-koni-compare-scroll-next]');
    var canScroll = this.scroll.scrollWidth > this.scroll.clientWidth + 2;
    if (prev) {
      prev.hidden = !canScroll || this.scroll.scrollLeft <= 2;
    }
    if (next) {
      next.hidden = !canScroll || this.scroll.scrollLeft + this.scroll.clientWidth >= this.scroll.scrollWidth - 2;
    }
  };

  KoniCompareTable.prototype.afterListChange = function () {
    this.compare.updateCompareCount();
    this.compare.setCompareButtonsState();
    if (typeof this.compare.updateCompareBar === 'function') {
      this.compare.updateCompareBar();
    }
    if (!this.getHandles().length && typeof this.compare.closeCompareModal === 'function') {
      this.compare.closeCompareModal();
    }
  };

  KoniCompareTable.prototype.bindEvents = function () {
    var self = this;
    if (!this.root || this._eventsBound) return;
    this._eventsBound = true;

    this.root.addEventListener('click', function (event) {
      var modeBtn = event.target.closest('[data-koni-compare-mode]');
      if (!modeBtn || !self.root.contains(modeBtn)) return;

      event.preventDefault();
      var mode = modeBtn.getAttribute('data-koni-compare-mode');
      self.diffOnly = mode === 'diff';

      self.root.querySelectorAll('[data-koni-compare-mode]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn === modeBtn);
      });

      self.applyDifferenceFilter();
      self.updateScrollButtons();
    });

    this.root.addEventListener('click', function (event) {
      var removeBtn = event.target.closest('.koni-compare-product__remove');
      if (!removeBtn || !self.root.contains(removeBtn)) return;

      event.preventDefault();
      var handle = removeBtn.getAttribute('data-product-handle');
      if (!handle) return;

      self.compare.removeFromCompare(handle);
      self.afterListChange();

      if (!self.getHandles().length) {
        self.showEmpty();
        return;
      }

      self.render();
    });

    var prev = this.root.querySelector('[data-koni-compare-scroll-prev]');
    var next = this.root.querySelector('[data-koni-compare-scroll-next]');
    if (prev) {
      prev.addEventListener('click', function () {
        if (!self.scroll) return;
        self.scroll.scrollBy({ left: -280, behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        if (!self.scroll) return;
        self.scroll.scrollBy({ left: 280, behavior: 'smooth' });
      });
    }

    if (this.scroll && !this.isModal) {
      this.scroll.addEventListener('scroll', function () {
        self.updateScrollButtons();
      });
      window.addEventListener('resize', function () {
        self.updateScrollButtons();
      });
    }
  };

  KoniCompareTable.prototype.render = async function () {
    if (!this.table) return;

    var handles = this.getHandles();
    if (!handles.length) {
      this.showEmpty();
      return;
    }

    var results = await Promise.all(handles.map(this.fetchProduct.bind(this)));
    this.products = [];
    handles.forEach(function (handle, index) {
      if (results[index]) this.products.push(results[index]);
    }, this);

    if (!this.products.length) {
      this.showEmpty();
      return;
    }

    this.showTable();
    if (this.isModal) {
      this.updateModalSize();
    }
    this.table.innerHTML = this.buildTableHTML(this.products);
    this.table.classList.add('is-visible');
    this.applyDifferenceFilter();
    this.bindEvents();
    if (this.isModal) {
      if (!this._modalResizeBound) {
        this._modalResizeBound = true;
        var self = this;
        window.addEventListener('resize', function () {
          if (self.products.length) self.updateModalSize();
        });
      }
    } else {
      var self = this;
      requestAnimationFrame(function () {
        self.updateScrollButtons();
        requestAnimationFrame(function () {
          self.updateScrollButtons();
        });
      });
    }
  };

  window.MinimogTheme = window.MinimogTheme || {};
  window.MinimogTheme.KoniCompare = {
    initPage: function (compareProduct) {
      var pageRoot = document.querySelector('.koni-compare-page');
      if (!pageRoot) return null;
      var instance = new KoniCompareTable(compareProduct, { root: pageRoot });
      instance.render();
      return instance;
    },
    initModal: function (compareProduct) {
      var modal = document.querySelector('[data-koni-compare-modal]');
      if (!modal) return null;
      return new KoniCompareTable(compareProduct, {
        root: modal,
        table: modal.querySelector('[data-koni-compare-table]'),
        scroll: modal.querySelector('[data-koni-compare-scroll]'),
        emptyEl: modal.querySelector('[data-koni-compare-modal-empty]'),
        isModal: true
      });
    },
    init: function (compareProduct) {
      return this.initPage(compareProduct);
    }
  };
})();
